import axios from "axios";
import API from "../_helpers/endpointService";

export const getProjects = (data) => {
    // let str = "";
    // if (input.Name != "" && input.Name.trim().length > 0 && input.Status != "") {
    //     str = "?Projectname=" + input.Name.trim() + "&Status=" + input.Status;
    // }
    // else if(input.Name != "" && input.Name.trim().length > 0){
    //     str = "?Projectname=" + input.Name.trim();
    // }
    // else if(input.Status != ""){
    //     str = "?Status=" + input.Status;
    // }
    let apiUrl = API.GET_PROJECT + '?UserEmail=' + data.UserEmail + '&Projectname=' + data.Name +'&Status=' + data.Status +'&PageNumber=' + data.PageNumber + '&PageSize='+ data.PageSize;
    return (dispatch) => {
        dispatch({type:"SHOW_LOADER",data:true})
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                dispatch({type:"SHOW_LOADER",data:false})
                if (response?.status === 200) {
                    dispatch({ type: "PROJECT_LIST", data: response.data });             
                }
            })
            .catch((error) => {
                dispatch({type:"SHOW_LOADER",data:false})
            });

    };
};

export const getProjectNames = () => {
    var tempData = [
        {
            Value: 1,
            Text: "test"
        },
        {
            Value: 3,
            Text: "string"
        },
    ];
    return (dispatch) => {
        dispatch({ type: "PROJECT_NAMES", data: tempData });
    };
};

export const getProjectStatus = () => {
    let apiUrl = API.PROJECT_STATUS;
    return (dispatch) => {
      axios({
        method: "get",
        url: apiUrl,
      })
        .then((response) => {
          if (response?.status === 200) {
            dispatch({ type: "PROJECT_STATUS", data: response.data });
          } else {
          }
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
          }
        });
    };
};

